module.exports = { "default": require("core-js/library/fn/math/sinh"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/sinh.js
// module id = 1438
// module chunks = 0